export default "__VITE_ASSET__DwhjKDOJ__"